import { axiosClient } from "../client";


const queryString = require("query-string");

const SALE_ITEM_INFO_GET_ALL = (locationId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_SALES}/v1/location/${locationId}/reports/sales/item`;

const HOURLY_SALE_INFO_GET = (locationId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_SALES}/v1/location/${locationId}/reports/sales/hourly`;

const WEEKLY_SALE_INFO_GET = (locationId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_SALES}/v1/location/${locationId}/reports/sales/weekly`;

const MONTHLY_SALE_INFO_GET = (locationId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_SALES}/v1/location/${locationId}/reports/sales/monthly`;

export const fetchAllItemsReportInfo = (token, locationId, filterData, basedOnShift) => 
axiosClient({
  method: "GET",
  url: queryString.stringifyUrl({
    url: SALE_ITEM_INFO_GET_ALL(locationId),
    query: {  where: filterData, based_on_shift: basedOnShift }}, {sort: false, arrayFormat: 'comma', skipNull: true, skipEmptyString: true},
    
  ),
  headers: {
    "X-Role-Location": locationId,
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  },
});

export const fetchHourlySalesReport = (token, locationId, filterData) => 
  axiosClient({
    method: "GET",
    url: queryString.stringifyUrl({
      url: HOURLY_SALE_INFO_GET(locationId),
      query: {  where: filterData }}, {sort: false, arrayFormat: 'comma', skipNull: true, skipEmptyString: true},
      
    ),
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  export const fetchWeeklySalesReport = (token, locationId, filterData) => 
  axiosClient({
    method: "GET",
    url: queryString.stringifyUrl({
      url: WEEKLY_SALE_INFO_GET(locationId),
      query: {  where: filterData }}, {sort: false, arrayFormat: 'comma', skipNull: true, skipEmptyString: true},
      
    ),
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

    export const fetchMonthlySalesReport = (token, locationId, filterData) => 
  axiosClient({
    method: "GET",
    url: queryString.stringifyUrl({
      url: MONTHLY_SALE_INFO_GET(locationId),
      query: {  where: filterData }}, {sort: false, arrayFormat: 'comma', skipNull: true, skipEmptyString: true},
      
    ),
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
